document.addEventListener("DOMContentLoaded", function () {
    const lazyBackgrounds = document.querySelectorAll('.lazy-bg');

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const div = entry.target;
                    const bg = div.getAttribute('data-bg');
                    if (bg) {
                        div.style.backgroundImage = `url(${bg})`;
                        div.classList.remove('lazy-bg');
                        observer.unobserve(div);
                    }
                }
            });
        });

        lazyBackgrounds.forEach(div => observer.observe(div));
    } else {
        // Fallback för äldre browsers – ladda direkt
        lazyBackgrounds.forEach(div => {
            const bg = div.getAttribute('data-bg');
            if (bg) {
                div.style.backgroundImage = `url(${bg})`;
            }
        });
    }
});
//# sourceMappingURL=lazyload.js.map
